export default __webpack_public_path__ + "static/media/sparck-appreciation-card-header-1.df9a3962.png";